import styled from 'styled-components';
import { MdArrowForward, MdKeyboardArrowRight } from 'react-icons/md';

const HeroContainer = styled.div`
  /* margin-top: -80px;  // transparent header */

  background: #0c0c0c;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 30px;
  height: calc(80vh + 80px);
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%);
    z-index: 2;
  }
`;

const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #2d3423;
`;

const HeroContent = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  z-index: 3;
  max-width: 1200px;
  padding: 8px 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 40px;
  }
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-size: 32px;
  text-align: center;
  max-width: 1000px;

  @media (min-width: 480) {
    font-size: 40px;
  }

  @media (min-width: 768px) {
    font-size: 52px;
  }
`;

const HeroSubtitle = styled.p`
  margin-top: 24px;
  font-size: 16px;
  color: #eee;
  max-width: 600px;
  text-align: center;

  @media (min-width: 480) {
    font-size: 20px;
  }

  @media (min-width: 768px) {
    margin-top: 24px;
  }
`;

const HeroButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: 20px;
  transition: all 0.3s ease;
`;

const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: 20px;
  transition: all 0.3s ease;
`;

export {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  HeroButtonWrapper,
  ArrowForward,
  ArrowRight
};
